import { useState } from 'react';
import axios from 'axios';
import { Download, Loader2, ChevronDown } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function DomiciliacionExportButton() {
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [busy, setBusy] = useState(false);

  const download = async (format) => {
    setBusy(true);
    try {
      const token = localStorage.getItem('token');
      const params = { format };
      if (from) params.from = from;
      if (to) params.to = to;
      const res = await axios.get(`${BACKEND_URL}/api/orders/domiciliacion/export`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `domiciliacion.${format === 'xlsx' ? 'xlsx' : 'csv'}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setOpen(false);
    } catch {
      /* no-op */
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
        data-testid="dom-export-toggle"
      >
        <Download className="w-4 h-4" />
        Exportar domiciliación
        <ChevronDown className="w-3.5 h-3.5" />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-72 bg-white border border-gray-200 rounded-xl shadow-lg z-20 p-4" data-testid="dom-export-panel">
          <p className="text-xs text-gray-500 mb-3">Cobros de domiciliación (liquidados y pendientes) por rango de fechas.</p>
          <div className="grid grid-cols-2 gap-2 mb-3">
            <div>
              <label className="text-[11px] text-gray-500">Desde</label>
              <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="w-full px-2 py-1.5 border rounded text-sm" data-testid="dom-export-from" />
            </div>
            <div>
              <label className="text-[11px] text-gray-500">Hasta</label>
              <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-full px-2 py-1.5 border rounded text-sm" data-testid="dom-export-to" />
            </div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => download('csv')} disabled={busy} className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm text-white disabled:opacity-50" style={{ backgroundColor: '#003594' }} data-testid="dom-export-csv">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'CSV'}
            </button>
            <button onClick={() => download('xlsx')} disabled={busy} className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50" data-testid="dom-export-xlsx">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Excel'}
            </button>
          </div>
          {!from && !to && <p className="text-[10px] text-gray-400 mt-2">Sin rango: se exportan los últimos 90 días.</p>}
        </div>
      )}
    </div>
  );
}
